import React from 'react';
import { Area, Text, useTheme } from '@ublend-npm/aulaui-core';

type Props = {
  description?: string;
  sx?: Record<string, unknown>;
  title?: string;
};

const SearchNoResults = ({
  description = 'Remember to check the spelling.',
  sx,
  title = 'No results found!',
}: Props) => {
  const theme = useTheme();

  return (
    <Area
      transparent
      rounded
      role="status"
      aria-live="polite"
      sx={{ textAlign: 'center', ...sx }}
    >
      <Text kind="p1">{title}</Text>
      {description && (
        <Text kind="p2" sx={{ color: theme.palette.text.secondary }}>
          {description}
        </Text>
      )}
    </Area>
  );
};

export default SearchNoResults;
